import { render } from "./ReportTitle.vue?vue&type=template&id=365696c2&scoped=true"
import script from "./ReportTitle.vue?vue&type=script&lang=js"
export * from "./ReportTitle.vue?vue&type=script&lang=js"

import "./ReportTitle.vue?vue&type=style&index=0&id=365696c2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-365696c2"]])

export default __exports__